function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M437 75c100 100 100 262 0 362s-262 100-362 0-100-262 0-362 262-100 362 0zM256 204l-43-43c-14-14-38-14-52 0-14 15-14 38 0 52l43 43-43 43c-14 14-14 38 0 52 15 14 38 14 52 0l43-43 43 43c14 14 38 14 52 0 14-15 14-38 0-52l-43-43 43-43c14-14 14-38 0-52-15-14-38-14-52 0z"
})));